import { render, staticRenderFns } from "./MenuCustomerListIcon.vue?vue&type=template&id=6431b2b2&"
import script from "./MenuCustomerListIcon.vue?vue&type=script&lang=ts&"
export * from "./MenuCustomerListIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports